// Shared by the Affidea Day on Tour '26 games. value is the result (ms for the puzzle,
// points for Health Rush); at is when it was saved.
export type Entry = { name: string; value: number; at: number };
// "asc": lower is better (time); "desc": higher is better (score).
export type Order = "asc" | "desc";

// One play per name: "João  Silva" and "joao silva" count as the same player.
export const normalizeName = (name: string) =>
  name.trim().replace(/\s+/g, " ").toLowerCase().normalize("NFD").replace(/\p{M}/gu, "");

export const nameTaken = (entries: Entry[], name: string) =>
  entries.some((e) => normalizeName(e.name) === normalizeName(name));

export function loadEntries(storageKey: string): Entry[] {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey) ?? "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    console.warn(`Classificação inválida no localStorage (${storageKey})`);
    return [];
  }
}

export function saveEntries(storageKey: string, entries: Entry[]) {
  window.localStorage.setItem(storageKey, JSON.stringify(entries));
}

// Best first; ties go to whoever finished first.
export const rankEntries = (entries: Entry[], order: Order) =>
  [...entries].sort((a, b) => (order === "asc" ? a.value - b.value : b.value - a.value) || a.at - b.at);

export const formatTime = (ms: number) => {
  const seconds = Math.floor(ms / 1000);
  return `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
};

const csvField = (value: string | number) => `"${String(value).replace(/"/g, '""')}"`;

// ";" because Portuguese Excel uses it as the list separator; BOM so accents open correctly.
export function toCsv(
  entries: Entry[],
  order: Order,
  valueHeader: string,
  format: (value: number) => string,
) {
  const lines = rankEntries(entries, order).map((e) =>
    [e.name, format(e.value), new Date(e.at).toISOString()].map(csvField).join(";"),
  );
  return "﻿" + [`nome;${valueHeader};data`, ...lines].join("\r\n");
}
